import ContractManagementContractFormView from './ContractManagementContractFormView';

export default ContractManagementContractFormView;
